import type { QuotationStatus } from "@/mocks/quotationsData";
import { allQuotationStatuses } from "@/mocks/quotationsData";

type Props = {
  search: string;
  onSearchChange: (v: string) => void;
  statusFilter: QuotationStatus | "All";
  onStatusChange: (v: QuotationStatus | "All") => void;
  dateFilter: string;
  onDateChange: (v: string) => void;
  agentFilter: string;
  onAgentChange: (v: string) => void;
  agents?: string[];
};

export function QuotationFilterBar({
  search,
  onSearchChange,
  statusFilter,
  onStatusChange,
  dateFilter,
  onDateChange,
  agentFilter,
  onAgentChange,
  agents = []
}: Props) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4">
      <div className="flex flex-wrap items-center gap-3">
        {/* Search */}
        <div className="relative flex-1 min-w-[220px] max-w-sm">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
          <input
            type="text"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search by lead, company, quote no..."
            className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg bg-gray-50 focus:bg-white focus:border-indigo-300 focus:ring-1 focus:ring-indigo-100 outline-none transition-all"
          />
        </div>

        {/* Status filter */}
        <div className="flex items-center gap-1 bg-gray-50 rounded-lg p-0.5 border border-gray-200">
          {(["All", ...allQuotationStatuses] as const).map((s) => (
            <button
              key={s}
              onClick={() => onStatusChange(s)}
              className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all whitespace-nowrap ${
                statusFilter === s ? "bg-white text-gray-900 shadow-sm" : "text-gray-500 hover:text-gray-700"
              }`}
            >
              {s}
            </button>
          ))}
        </div>

        {/* Date filter */}
        <div className="flex items-center gap-1 bg-gray-50 rounded-lg p-0.5 border border-gray-200">
          {["Today", "This Week", "This Month"].map((d) => (
            <button
              key={d}
              onClick={() => onDateChange(dateFilter === d ? "" : d)}
              className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all whitespace-nowrap ${
                dateFilter === d ? "bg-white text-gray-900 shadow-sm" : "text-gray-500 hover:text-gray-700"
              }`}
            >
              {d}
            </button>
          ))}
        </div>

        {/* Agent filter */}
        <select
          value={agentFilter}
          onChange={(e) => onAgentChange(e.target.value)}
          className="px-3 py-2 text-sm border border-gray-200 rounded-lg bg-gray-50 text-gray-700 outline-none focus:border-indigo-300 focus:ring-1 focus:ring-indigo-100"
        >
          <option value="">All Agents</option>
          {agents.map((a) => (
            <option key={a} value={a}>{a}</option>
          ))}
        </select>
      </div>
    </div>
  );
}